"use client";

import React from "react";
import "../privacy-policy/PrivacyPolicy.scss";
import Link from "next/link";
import { ReactSVG } from "react-svg";

const StorePolicy = () => {
  return (
    <div className='PrivacyPolicy-wrapper'>
      <div className='PrivacyPolicy-header-wrapper'>
        <div className='breadcrumbs-wrapper'>
          <Link
            href={"/"}
            className='text-xsmall-18 grey-100 weight-600'
            style={{ opacity: 0.5 }}>
            HOME
          </Link>
          <ReactSVG src='/assets/next-arrow-small-ic.svg' />
          <p className='text-xsmall-18 white weight-700'>STORE POLICIES</p>
        </div>
        <p className='section-main-header large white'>Store Policies</p>
      </div>

      <div className='PloicyBody'>
        <div className='wrapper'>
          <div className='right'>
            <div className='textBlock'>
              <div className='textWrapper'>
                <p className='title'>Delivery for In-Store Purchases</p>
                <p className='desc'>
                  At Amherst Supply, we aim to provide convenient same or
                  next-day delivery service at a fair and affordable price.
                  Please contact us for pricing by email at{' '}
                  <Link
                    href="mailto:hello@amherstsupply.com"
                    className="text-medium-24 blue-500"
                    style={{ cursor: 'pointer' }}
                  >
                    hello@amherstsupply.com
                  </Link>{' '}or call{' '}
                  <Link
                    href="tel:5197139318"
                    className="text-medium-24 blue-500"
                    style={{ cursor: 'pointer' }}
                  >
                    (519) 713-9318
                  </Link>.
                  <br />
                  <br />
                  We will make every reasonable effort to place your product as
                  close as possible to where it is to be used, extra services
                  (including but not limited to, the placement of product
                  anywhere other than where it can be placed via flatbed truck
                  or directly off load from the truck) will acquire additional
                  charges.
                  <br />
                  <br />
                  Clear communication by our customers regarding specific
                  delivery concerns and situations at point of order is
                  immensely helpful in ensuring a successful delivery
                  experience.
                </p>
              </div>
            </div>
            <div className='textBlock'>
              <div className='textWrapper'>
                <p className='title'>In-Store Special Order Policy</p>
                <br /> <br />
                <p className='desc'>
                  We can special order your item if it is not a regularly
                  stocked product, subject to the following policies:
                </p>
                <br /> <br />
                <p className='desc'>
                  <ul>
                    <li>
                      All special orders are subject to a minimum 50% Deposit at
                      the time of order.
                      <br />
                      <br />
                    </li>
                    <li>
                      No returns will be accepted on special orders or
                      non-stocked merchandise.
                      <br />
                      <br />
                    </li>
                    <li>
                      All special-order items and deposits are non-refundable.
                      <br />
                      <br />
                    </li>
                    <li>
                      Once a special order is placed with our suppliers, it
                      cannot be cancelled.
                      <br />
                      <br />
                    </li>
                    <li>
                      We are not responsible for production delays or other
                      unforeseen circumstances that delay delivery of any
                      special order. We will provide an estimate of the lead
                      time required for your item to come in as accurately as
                      possible; however, we cannot guarantee a lead time in any
                      case.
                      <br />
                      <br />
                    </li>
                    <li>
                      Once a special order &quot;non-stock&quot; item is
                      delivered to us, we will promptly call to set-up
                      delivery/pick-up. Amherst Supply cannot hold special order
                      non-stocked items. If a special order non-stock item
                      cannot be picked up or delivered within 7 days, Amherst
                      Supply will not be held responsible for anything that
                      happens to the order/items thereafter.
                      <br />
                      <br />
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className='textBlock'>
              <div className='textWrapper'>
                <p className='title'>Special Order Claims</p>
                <p className='desc'>
                  <ul>
                    <li>
                      DAMAGE claims, or claims for MISSING PRODUCT must be made
                      within 24 hours of delivery. Pictures may be required in
                      the event of defects/damages before a claim can be
                      authorized.
                    </li>
                    <li>
                      CONCEALED DAMAGE must be reported within 48 hours of
                      delivery, and the product must be returned in original
                      undamaged packaging.
                    </li>
                  </ul>
                  Customers will be asked to sign a form acknowledging our
                  special order policies and that they have reviewed the order
                  for accuracy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorePolicy;
